import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full border border-background-300/80 text-xs font-semibold text-foreground-500 font-label tracking-wide mb-4">
            Shop by Category
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
            Browse All Product Categories
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            Find exactly what you are looking for across our complete directory of verified CSSBuy spreadsheet categories
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat, index) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-xl bg-white border border-background-200/70 hover:bg-accent-500 hover:border-accent-500 transition-all duration-300 cursor-pointer"
              style={{ animationDelay: `${index * 50}ms` }}
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-100 text-foreground-400 group-hover:bg-white/20 group-hover:text-white transition-all duration-300">
                <i className={`${cat.icon} text-xl`}></i>
              </span>
              <span className="text-sm font-semibold text-foreground-700 group-hover:text-white transition-colors duration-300 text-center whitespace-nowrap">
                {cat.name}
              </span>
              <span className="w-5 h-5 flex items-center justify-center text-foreground-300 group-hover:text-white/70 group-hover:translate-x-0.5 transition-all duration-300">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}